import { useState, useEffect } from 'react';
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, ModalCloseButton, Button, Checkbox, VStack, HStack, Divider, Alert, AlertIcon, Box, Spinner } from "@chakra-ui/react";
import JobsController from 'controllers/Jobs/JobsController';
import FichasController from 'controllers/Fichas/FichasController';

function FullScreenModal() {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);
    const [selectedFichas, setSelectedFichas] = useState([]);
    const [step, setStep] = useState("files");
    const [filesToReprocess, setFilesToReprocess] = useState([]);
    const [fichas, setFichas] = useState([]);
    const [errorAlert, setErrorAlert] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [successAlert, setSuccessAlert] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const files = await JobsController.ListFilesToReprocess();
                setFilesToReprocess(files);
            } catch (error) {
                console.error("Error fetching files to reprocess:", error);
            }
        };

        if (isOpen && step === "files") {
            fetchData();
        }

        const fetchFichas = async () => {
            try {
                const fichas = await FichasController.ListFichas();
                setFichas(fichas);
            } catch (error) {
                console.error("Error fetching fichas:", error);
            }
        };

        if (isOpen && step === "records") {
            fetchFichas();
        }
    }, [isOpen, step]);

    const handleCheckboxChange = (id, type) => {
        if (type === "file") {
            setSelectedItems(prevSelectedItems => {
                if (prevSelectedItems.includes(id)) {
                    return prevSelectedItems.filter(item => item !== id);
                } else {
                    return [...prevSelectedItems, id];
                }
            });
        } else if (type === "ficha") {
            setSelectedFichas(prevSelectedFichas => {
                if (prevSelectedFichas.includes(id)) {
                    return prevSelectedFichas.filter(ficha => ficha !== id);
                } else {
                    return [...prevSelectedFichas, id];
                }
            });
        }
    };

    const handleCloseModal = () => {
        setSelectedItems([]);
        setSelectedFichas([]);
        setStep("files");
        setIsOpen(false);
        setErrorAlert(false);
        setSuccessAlert(false);
    };

    const handleCancel = () => {
        setSelectedItems([]);
        setSelectedFichas([]);
        setStep("files");
        setIsOpen(false);
        setErrorAlert(false);
        setSuccessAlert(false);
    };


    const handleNext = () => {
        if (step === "files" && selectedItems.length === 0) {
            setErrorAlert(true);
        } else if (step === "records" && selectedFichas.length === 0) {
            setErrorAlert(true);
        } else {
            setErrorAlert(false);
            setStep("records");
        }
    };


    const handleBack = () => {
        setStep("files");
    };

    const handleReprocess = async () => {
        if (selectedFichas.length === 0) {
            setErrorAlert(true);
            return;
        }

        setIsLoading(true);

        try {
            await JobsController.Reprocess(selectedItems, selectedFichas);
            console.log('Reprocessing completed successfully!');
            setSuccessAlert(true);
            setTimeout(() => {
                setIsOpen(false);
                setSelectedItems([]);
                setSelectedFichas([]);
                setStep("files");
                setErrorAlert(false);
                setSuccessAlert(false);
            }, 1000);
        } catch (error) {
            console.error('Error reprocessing:', error);
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <>
            <Button onClick={() => setIsOpen(true)} colorScheme="blue" width="auto" minWidth="150px" flexShrink={0} flexGrow={1} borderRadius="lg" >Reprocessar Arquivos</Button>
            <Modal isOpen={isOpen} onClose={handleCloseModal} size="auto">
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader textAlign="center">{step === "files" ? "Reprocessar Arquivos" : "Selecionar Fichas"}</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <VStack spacing={4} align="stretch">
                            {step === "files" ? (
                                filesToReprocess.map((item) => (
                                    <Box key={item.idtranscripts} borderWidth="1px" borderRadius="lg" p="4">
                                        <HStack align="start">
                                            <Checkbox
                                                isChecked={selectedItems.includes(item.idtranscripts)}
                                                onChange={() => handleCheckboxChange(item.idtranscripts, "file")}
                                                colorScheme="blue"
                                            >
                                                <p>ID da transcrição: {item.idtranscripts}</p>
                                            </Checkbox>
                                            <Divider orientation="vertical" />
                                            <p>Nome do arquivo: {item.recording_path.split('/').pop()}</p>
                                        </HStack>
                                    </Box>
                                ))
                            ) : (
                                fichas.map((ficha) => (
                                    <Box key={ficha.id} borderWidth="1px" borderRadius="lg" p="4">
                                        <Checkbox
                                            isChecked={selectedFichas.includes(ficha.id)}
                                            onChange={() => handleCheckboxChange(ficha.id, "ficha")}
                                            colorScheme="blue"
                                        >
                                            <p>ID da ficha: {ficha.id} Nome da ficha: {ficha.Nome}</p>
                                        </Checkbox>
                                    </Box>
                                ))
                            )}
                        </VStack>
                        {errorAlert && (
                            <Alert status="error" mt={4} borderRadius="md">
                                <AlertIcon />
                                {step === "files"
                                    ? "Por favor, selecione pelo menos um arquivo antes de avançar para a seleção de fichas."
                                    : "Por favor, selecione pelo menos uma ficha antes de concluir."
                                }
                            </Alert>
                        )}
                        {successAlert && (
                            <Alert status="success" mt={4} borderRadius="md">
                                <AlertIcon />
                                Arquivos carregados com sucesso!
                            </Alert>
                        )}
                    </ModalBody>
                    <ModalFooter>
                        {step === "files" ? (
                            <>
                                <Button onClick={handleCancel} mr={3} borderRadius="md">Cancelar</Button>
                                <Button onClick={handleNext} colorScheme="blue" borderRadius="md">Avançar</Button>
                            </>
                        ) : (
                            <>
                                <Button onClick={handleBack} mr={3} borderRadius="md">Voltar</Button>
                                <Button onClick={handleReprocess} colorScheme="blue" borderRadius="md" isLoading={isLoading}>
                                    {isLoading ? <Spinner size="sm" /> : 'Reprocessar'}
                                </Button>
                            </>
                        )}
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    );
}

export default FullScreenModal;